import { KeyValueModel } from '@models/common';
import { MimeTypesEnum } from '@models/module/fields/main';

export enum RestrictionType {
  ReadOnly = 1,
  Required = 2,
  NeedsToBeChecked = 3,
  Number = 4,
  DateTime = 5,
  MimeTypes = 6,
  ShowThousandSeparator = 7,
  MaximumLength = 8,
}

export enum RestrictionValueType {
  /** Some restrictions come with value: 0 */
  Unknown = 0,
  Decimal = 1,
  Integer = 2,
  Date = 3,
  DateTime = 4,
  Time = 5,
}

export const RestrictionTypeValues = new Map<RestrictionType, RestrictionValueType[]>([
  [RestrictionType.ReadOnly, []],
  [RestrictionType.Required, []],
  [RestrictionType.NeedsToBeChecked, []],
  [RestrictionType.Number, [RestrictionValueType.Decimal, RestrictionValueType.Integer]],
  [RestrictionType.DateTime, [RestrictionValueType.Date, RestrictionValueType.DateTime, RestrictionValueType.Time]],
  [RestrictionType.MimeTypes, []],
  [RestrictionType.ShowThousandSeparator, []],
  [RestrictionType.MaximumLength, []],
]);

export interface KeyValueRestrictionModel extends KeyValueModel<RestrictionType, RestrictionValueType> {
  mimeTypes?: number[];
  mimeTypesDataSource?: KeyValueModel<number, MimeTypesEnum>[];
  restrictionValue?: number;
}

export const BaseRestrictions = {
  DateTime: [
    {
      key: RestrictionType.DateTime,
      value: RestrictionValueType.DateTime,
    },
  ],
  Date: [
    {
      key: RestrictionType.DateTime,
      value: RestrictionValueType.Date,
    },
  ],
  Time: [
    {
      key: RestrictionType.DateTime,
      value: RestrictionValueType.Time,
    },
  ],
};

export const CurrencyRestrictions: KeyValueRestrictionModel[] = [
  { key: RestrictionType.Number, value: RestrictionValueType.Decimal },
  { key: RestrictionType.ShowThousandSeparator },
];
